import { render, staticRenderFns } from "./DistributorWholesalePrice.vue?vue&type=template&id=c7a501a6&"
import script from "./DistributorWholesalePrice.vue?vue&type=script&lang=js&"
export * from "./DistributorWholesalePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports